import styled from "styled-components";

import {
  COLORS,
  FONTS,
  FONT_SIZE,
  FONT_WEIGHT,
} from "../../../../constants/Styles";

const Container = styled.div`
  padding: 1rem;
  width: 100%;
  height: 100%;
  background-color: ${COLORS.background};
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: scroll;
`;

const ConsignmentPartsHeader = styled.div`
  text-align: center;
  font-size: ${FONT_SIZE.size18};
  color: ${COLORS.secondaryLight};
`;

const Body = styled.div`
  display: flex;
`;

const PartSearch = styled.div`
  overflow-x: scroll;
  flex: 1;
`;

const RightSection = styled.div`
  width: 20rem;
  margin-right: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const DetailsCard = styled.div`
  padding: 1.5rem;
  border: 1px solid ${COLORS.tableBackground};
  border-radius: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Title = styled.div`
  font-size: ${FONT_SIZE.size24};
  font-family: ${FONTS.spaceGrotesk};
`;

const PropertiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FootprintsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 1rem;
`;

const PropertyContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
`;

const MatchingElements = styled.div`
  color: ${COLORS.secondaryLight};
  font-weight: ${FONT_WEIGHT.weight500};
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

const MatchingElement = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  text-wrap: nowrap;

  > label {
    margin-left: 0.25rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const AdminPanel = styled.div`
  background-color: ${COLORS.tableBackground};
  padding: 1rem;
  border-radius: 1rem;
`;

const AdminTitle = styled.div`
  font-size: ${FONT_SIZE.size14};
  font-family: ${FONTS.spaceGrotesk};
`;

const UpdatePlacementFormContainer = styled.form`
  display: flex;
  justify-content: center;
  padding: 1rem;
  gap: 1rem;
  width: 100%;
  height: 100%;
`;

const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 15rem;
  gap: 1rem;
`;

const NoPartsHelpfulTip = styled.div`
  font-size: ${FONT_SIZE.size13};
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  color: ${COLORS.secondaryLight};
  gap: 0.25rem;
`;

export {
  Container,
  ConsignmentPartsHeader,
  Body,
  PartSearch,
  RightSection,
  FootprintsContainer,
  DetailsCard,
  Title,
  PropertiesContainer,
  PropertyContainer,
  MatchingElements,
  MatchingElement,
  ButtonContainer,
  AdminPanel,
  UpdatePlacementFormContainer,
  AdminTitle,
  NoPartsHelpfulTip,
  FieldsContainer,
};
